import {Email} from './Email';
export default Email;